var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#444444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.62-120q-27.62 0-46.12-18.5Q200-157 200-184.62v-430.76q0-27.62 18.5-46.12Q237-680 264.62-680H340v-20q0-58.31 40.85-99.15Q421.69-840 480-840t99.15 40.85Q620-758.31 620-700v20h75.38q27.62 0 46.12 18.5Q760-643 760-615.38v430.76q0 27.62-18.5 46.12Q723-120 695.38-120H264.62Zm0-40h430.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-430.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H620v100q0 8.54-5.73 14.27T600-520q-8.54 0-14.27-5.73T580-540v-100H380v100q0 8.54-5.73 14.27T360-520q-8.54 0-14.27-5.73T340-540v-100h-75.38q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v430.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69ZM380-680h200v-20q0-42.23-28.88-71.12Q522.23-800 480-800q-42.23 0-71.12 28.88Q380-742.23 380-700v20ZM240-160v-480 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagIc);
export default __webpack_public_path__ + "static/media/shopping_bag_ic.2a18e159aafb8675ce627c18ea84973a.svg";
export { ForwardRef as ReactComponent };